import { PROCESS } from "../mock";

export default function Process() {
  return (
    <section id="process" className="relative py-28 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           The Process
          </div>
          <h2 className="font-display text-5xl md:text-6xl leading-[0.95]">
            Methodical.<br />
            <span className="text-jester">Measurable.</span><br />
            <span className="font-marker text-acid text-3xl md:text-4xl inline-block mt-3">
              meticulous.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 rounded-2xl overflow-hidden">
          {PROCESS.map((p, i) => (
            <div
              key={i}
              className="group relative bg-[#0d0119] hover:bg-[#1a0938] transition-colors duration-700 p-10 min-h-[320px] flex flex-col items-center text-center justify-between overflow-hidden"
            >
              <div className="font-stencil text-7xl text-white/8 group-hover:text-jester/35 transition-colors duration-700">
                {p.step}
              </div>
              <div className="w-full">
                <h3 className="font-display text-lg md:text-xl tracking-wide mb-3 leading-tight whitespace-nowrap">
                  {p.title}
                </h3>
                <p className="text-white/65 text-sm leading-relaxed max-w-[260px] mx-auto">
                  {p.desc}
                </p>
              </div>
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 h-1 w-0 group-hover:w-full bg-acid transition-all duration-700" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
